<div class="text-white bg-black/70 p-8 rounded-2xl max-w-[500px] w-full" (submit)="search($event)">
  <div class=" max-w-none text-white">
    <h1 class="text-2xl font-thin mb-4 text-white uppercase ">Find your <br><span class="text-primary text-4xl font-black">PURE PUNJABI RISHTA</span></h1>
    <form>
      @if (!authService.isLoggedIn()) {
        <label for="" class="mb-2 block">I am looking for a</label>
        <app-sex-selector [formField]="form.sex" [options]="[{label:'Bride',value:'female'},{label:'Groom',value:'male'}]"></app-sex-selector>
      }
      <button class="btn-base text-white bg-primary w-full mt-4 gap-2 center-all animate-all hover:gap-4">Start Your Search
        <i class="fa-thin fa-arrow-right-long"></i>
      </button>
    </form>
  </div>
</div>
